import { MapContainer, TileLayer, CircleMarker, Tooltip } from "react-leaflet";

// Approximate country centroids for demo
const COUNTRY_COORDS = {
  "Estados Unidos": [39.0, -98.0],
  "EE. UU.": [39.0, -98.0],
  "España": [40.4, -3.7],
  "México": [23.6, -102.5],
  "Italia": [41.9, 12.5],
  "Argentina": [-38.4, -63.6],
  "Brasil": [-14.2, -51.9],
  "Francia": [46.6, 2.2],
  "Alemania": [51.1, 10.4],
  "Japón": [36.2, 138.2],
  "Países Bajos": [52.1, 5.3],
  "Chile": [-35.7, -71.5],
  "Perú": [-9.2, -75.0],
  "Colombia": [4.6, -74.1],
  "Reino Unido": [54.0, -2.0],
  "Portugal": [39.4, -8.2],
  "China": [35.9, 104.2],
  "Canadá": [56.1, -106.3],
};

export default function MapaTerritorial({ distribucion = [] }) {
  const points = distribucion
    .map((d) => {
      const coords = COUNTRY_COORDS[d.pais];
      if (!coords) return null;
      return { ...d, lat: coords[0], lng: coords[1] };
    })
    .filter(Boolean);

  const maxTotal = Math.max(1, ...points.map((p) => p.total));

  return (
    <div className="border border-zinc-200 h-[420px] overflow-hidden" data-testid="mapa-territorial">
      <MapContainer center={[20, 0]} zoom={2} scrollWheelZoom={false} style={{ height: "100%", width: "100%" }}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a> &copy; <a href="https://carto.com/">CARTO</a>'
          url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
        />
        {points.map((p) => {
          const radius = 6 + (p.total / maxTotal) * 18;
          const color = p.activos > 0 ? "#047857" : "#71717a";
          return (
            <CircleMarker
              key={p.pais}
              center={[p.lat, p.lng]}
              radius={radius}
              pathOptions={{ color, fillColor: color, fillOpacity: 0.4, weight: 2 }}
            >
              <Tooltip direction="top">
                <div style={{ fontFamily: "Geist, sans-serif" }}>
                  <strong>{p.pais}</strong>
                  <br />
                  {p.total} convenios · {p.activos} activos
                </div>
              </Tooltip>
            </CircleMarker>
          );
        })}
      </MapContainer>
    </div>
  );
}
